






















































































import { Subscription, SubEvent, Favorite } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../../models/event';
import Modal from '../base/Modal.vue';
import toast from '../toast';
import { ToastType } from '../toast/tost-type.enum';

@Component({
  components: {
    Modal,
  },
})
export default class TalksInfoComponent extends Vue {
  @Prop({ required: true, type: Event })
  private event!: Event;

  @Prop({ required: true })
  private subscriptions!: Array<Subscription>;

  private commentsModalData: Array<{ name: string; comment: string }> = null;

  $refs!: {
    commentsModal: Modal;
  };

  get palestras_ranked() {
    return this.event.subEvents.reduce((obj, { _id }) => {
      obj[_id] = this.subscriptions.filter(({ favorites }) =>
        (favorites || []).find((elm: Favorite) => elm._id === _id),
      );
      return obj;
    }, {});
  }

  getCommentsQuantityForPalestra({ _id }: SubEvent): number {
    const index = this.event.subEvents.findIndex((elm) => elm._id === _id);
    if (index === -1) {
      return 0;
    }
    return this.subscriptions.filter(
      (subscription) => !!subscription[`sugestao_${this.suggestion_index_based ? index : index + 1}`],
    ).length;
  }

  get palestras_grouped_by_name_ordered(): Array<{ name: string; image: string; rank: number; comments: number }> {
    return (Object.entries(this.palestras_ranked) as Array<[string, Array<Subscription>]>)
      .map(([_id, rows]: [string, Array<Subscription>]) => {
        const subEvent = this.event.subEvents.find((elm) => elm._id === _id);
        return {
          _id,
          name: subEvent?.info.name,
          image: subEvent?.info.image,
          rank: rows.length,
          comments: this.getCommentsQuantityForPalestra({ _id } as SubEvent),
        };
      })
      .sort(({ rank: rankA }, { rank: rankB }) => rankB - rankA);
  }

  getCommentsForPalestra({ _id }: SubEvent): Array<{ name: string; comment: string }> {
    const index = this.event.subEvents.findIndex((elm) => elm._id === _id);
    if (index === -1) {
      return [];
    }
    return this.subscriptions
      .filter((subscription) => !!subscription[`sugestao_${this.suggestion_index_based ? index : index + 1}`])
      .flatMap((subscription) => ({
        name: subscription.nome || '',
        comment: subscription[`sugestao_${this.suggestion_index_based ? index : index + 1}`],
      }));
  }

  openCommentsModal({ _id }: SubEvent) {
    const index = this.event.subEvents.findIndex((elm) => elm._id === _id);
    const subEvent = this.event.subEvents[index];
    if (!this.getCommentsQuantityForPalestra(subEvent)) {
      return toast('Atenção, não há comentários de expectativa para esta palestra', ToastType.WARNING);
    }

    this.commentsModalData = this.getCommentsForPalestra(subEvent);
    this.$refs.commentsModal.open();
  }

  closeCommentsModal() {
    this.$refs.commentsModal.close();
  }

  get suggestion_index_based(): boolean {
    return this.event.subEvents[0]?.cardFields[0]?.id === 'sugestao_0';
  }
}
